import { greaterThan } from 'ngrx-forms/validation';
import { BuildValidatorWithComparandDecorator } from './helpers';

export const GreaterThan = BuildValidatorWithComparandDecorator<number>(
  greaterThan, 'DX.FORMS.VALIDATION.ERRORS.GREATER_THEN'
);
